import { Component, EventEmitter, Input, OnInit, Output, Injectable, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ReajusteAutomaticoContratoService } from '@services/reajuste-automatico-contrato.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { isSafeHtml } from '@utils/html-sanitizer.util';

@Component({
    selector: 'app-auto-readjustment-contract',
    templateUrl: './auto-readjustment-contract.component.html',
    styleUrls: ['./auto-readjustment-contract.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
@Injectable({
  providedIn: 'root',
})
export class AutoReadjustmentContractComponent implements OnInit {
  @Input() alertFecharBanner: boolean = false;
  @Output() alertFecharBannerFechou = new EventEmitter();
  @ViewChild('iframeBanner') iframeBanner: HTMLIFrameElement;

  private readonly idEmpresaLogada: string;
  public strBanner: SafeHtml;

  constructor(private readonly readjustmentService: ReajusteAutomaticoContratoService, private readonly sanitizer: DomSanitizer) {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
  }

  ngOnInit(): void {
    this.hasReadjustmentToShow();
  }

  fecharModal() {
    this.readjustmentService.putReadjustmentBanner(this.idEmpresaLogada)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.alertFecharBanner = false;
          this.alertFecharBannerFechou.emit(this.alertFecharBanner);
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }

hasReadjustmentToShow() {
    this.readjustmentService.getReadjustmentBanner(this.idEmpresaLogada)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response !== null && isSafeHtml(response)) {
            this.strBanner = this.sanitizer.bypassSecurityTrustHtml(response); // NOSONAR - S6268: HTML validado por isSafeHtml() antes do bypass
            this.alertFecharBanner = true;
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }
}
